// During prototype: Vite resolves these from local disk.
// For Webflow embed: swap these for R2 bucket URLs.

import avatarUrl from "../../../Images/IO Assets/Avatar/Avatar.png?url";
import icon0Url from "../../../Images/IO Assets/Icons/card inGame.png?url";
import icon1Url from "../../../Images/IO Assets/Icons/card inGame-1.png?url";
import icon2Url from "../../../Images/IO Assets/Icons/card inGame-2.png?url";
import icon3Url from "../../../Images/IO Assets/Icons/card inGame-3.png?url";
import icon4Url from "../../../Images/IO Assets/Icons/card inGame-4.png?url";
import icon5Url from "../../../Images/IO Assets/Icons/card inGame-5.png?url";
import icon6Url from "../../../Images/IO Assets/Icons/card inGame-6.png?url";
import icon7Url from "../../../Images/IO Assets/Icons/card inGame-7.png?url";
import icon8Url from "../../../Images/IO Assets/Icons/card inGame-8.png?url";
import feelingLuckyUrl from "../../../Images/IO Assets/Icons/card_feeling lucky.png?url";

export interface IconAsset {
  url: string;
  isSpecial: boolean;
}

export const AVATAR_URL: string = avatarUrl;

export const REGULAR_ICONS: IconAsset[] = [
  { url: icon0Url, isSpecial: false },
  { url: icon1Url, isSpecial: false },
  { url: icon2Url, isSpecial: false },
  { url: icon3Url, isSpecial: false },
  { url: icon4Url, isSpecial: false },
  { url: icon5Url, isSpecial: false },
  { url: icon6Url, isSpecial: false },
  { url: icon7Url, isSpecial: false },
  { url: icon8Url, isSpecial: false },
];

export const SPECIAL_ICON: IconAsset = { url: feelingLuckyUrl, isSpecial: true };

export function pickRandomIcon(exclude?: IconAsset): IconAsset {
  // ~10% chance of the special Gemini icon (skip if it was last)
  if (Math.random() < 0.1 && exclude !== SPECIAL_ICON) return SPECIAL_ICON;
  const pool = exclude ? REGULAR_ICONS.filter(i => i !== exclude) : REGULAR_ICONS;
  return pool[Math.floor(Math.random() * pool.length)]!;
}
